import { fabric } from "fabric";
import type { CanvasPaperConfig } from "../designer/PageDesigner/PageDesigner";
import { getNumberOfPages } from "./page-panning";

export function createPageDividerLines(
  canvas: fabric.Canvas,
  dimensions: CanvasPaperConfig,
): fabric.Line[] {
  const pagesNeeded = getNumberOfPages(canvas, dimensions);
  const lines: fabric.Line[] = [];

  if (pagesNeeded > 1) {
    for (let i = 1; i <= pagesNeeded; i++) {
      const y = dimensions.height * i;
      const pageBreakerLine = new fabric.Line([0, y, dimensions.width, y], {
        stroke: "lightgrey",
        selectable: false,
        hoverCursor: "default",
        evented: false,
      });
      canvas.add(pageBreakerLine);
      lines.push(pageBreakerLine);
    }
    canvas.requestRenderAll();
  }

  return lines;
}
